'use client';
import CourseListItem from '@/components/Course/CourseListItem';
import { ArrowUpRightIcon } from '@heroicons/react/16/solid';
import ModalForm from '../Modal/Modal';
import { ReactNode, useState } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface ProposalListBlockProps {
  title: ReactNode | SerializedEditorState;
  list: Array<{
    title: ReactNode | SerializedEditorState;
    txtContent1: {
      title: ReactNode | SerializedEditorState;
      subtitle: ReactNode | SerializedEditorState;
    };
    txtContent2: {
      title: ReactNode | SerializedEditorState;
      subtitle: ReactNode | SerializedEditorState;
    };
  }>;
  color?: 'violet' | 'green' | 'blue';
  showMoreBtn?: boolean;
  btnText?: string;
  btnTag?: string;
}

export default function CourseBlock({
  title,
  list,
  color = 'green',
  showMoreBtn = false,
  btnText,
  btnTag,
}: ProposalListBlockProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  const backgroundColorClass =
    {
      green: 'custom-gradient-green-btn',
      blue: 'custom-gradient-blue-btn',
      violet: 'custom-gradient-violet-btn',
    }[color] || 'custom-gradient-green-btn';
  return (
    <>
      <div
        data-meta="CourseBlock"
        className={`container mx-auto px-2 sm:px-6 lg:px-8 mb-14 flex flex-col justify-center rounded-3xl`}
      >
        <CustomRichText
          data={title}
          tag="h2"
          className="text-4xl font-bold tracking-tight text-center text-white sm:text-6xl my-8"
        />
        <div className="grid grid-cols-1 gap-2 lg:gap-4 pt-4  pb-12 lg:px-8">
          {list.map((item, index) => (
            <CourseListItem
              key={index}
              title={item.title}
              txtContent1={item.txtContent1}
              txtContent2={item.txtContent2}
            />
          ))}
        </div>
        {showMoreBtn && (
          <div className="flex justify-center">
            <button
              onClick={openForm}
              className={`pl-8 pr-1 py-1 text-lg font-bold text-white uppercase rounded-full ring-${color}-500 ring-1 flex gap-2 items-center`}
            >
              <span className="text-sm sm:text-sm md:text-lg">{btnText}</span>
              <div className={`rounded-full ${backgroundColorClass}`}>
                <ArrowUpRightIcon className="text-white lg:h-[16px] lg:w-[16px] xl:h-[24px] xl:w-[24px] m-2 xl:m-[6px] w-4 h-4" />
              </div>
            </button>
          </div>
        )}
      </div>
      {isFormOpen && (
        <ModalForm closeForm={closeForm} btnMeta={{ tag: btnTag ?? '' }} color={color} />
      )}
    </>
  );
}
